import { Types } from './types'

const initialState = {
    dataBill: {
        filter: {},
        rows: []
    },
}
const bankReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_BILL:
            return {
                ...newState,
                dataBill: action.payload
            }
        default:
            return { ...newState }
    }
}
export default bankReducer
